import Draft from '@/components/library/pages/Draft.vue';
import Email from '@/components/library/pages/Email.vue';
import Flagship from '@/components/library/pages/Flagship.vue';
import Published from '@/components/library/pages/Published.vue';
import Unpublished from '@/components/library/pages/Unpublished.vue';
import DocumentLibrary from '@/views/DocumentLibrary.vue';

export const documents = [{
  path: '/documents/',
  name: 'document-library',
  component: DocumentLibrary,
  meta: { title: 'Library' },
  children: [
    {
      name: 'email',
      path: 'email',
      component: Email,
      meta: { title: 'Emails' },
    },
    {
      name: 'published',
      path: 'published',
      component: Published,
      meta: { title: 'Published Posts' },
    },
    {
      name: 'unpublished',
      path: 'unpublished',
      component: Unpublished,
      meta: { title: 'Unpublished Posts' },
    },
    {
      name: 'draft',
      path: 'draft',
      component: Draft,
      meta: { title: 'Draft Posts' },
    },
    {
      name: 'flagship',
      path: 'flagship',
      component: Flagship,
      meta: { title: 'Flagship Posts' },
    },
    {
      name: 'closed',
      path: 'closed',
      redirect: (to) => ({ name: 'unpublished', query: { ...to.query, closedRedirect: 'true' } }),
    },
  ],
}];
